// Clinic Configuration for Dentist In Concord
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Austin",
  clinicId: "dentistinaustin",
  clinicUrl: "https://dentistinaustintx.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinaustin&agentId=9f4730a3-ae0a-445e-853a-3710050a95cf",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinaustin/voice",

  // Contact Information
  phoneNumber: "5124304472",
  phoneNumberRaw: "+15124304472", // For tel: and sms: links
  email: "dentalcare@dentistinaustintx.com",

  // Location
  address: "2110 W Slaughter Ln Ste 190, Austin, TX 78748, United States",
  addressShort: "2110 W Slaughter Ln Ste 190, Austin, TX 78748, USA",
  city: "Austin",
  hcity: "Austin",
  state: "Texas",
  stateShortForm: "TX",
  PostalCode: "78748",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/zNd6h5pCWYV1wxs57",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d104912.66240333545!2d-97.823794!3d30.174754!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865b4cf440b822df%3A0x4432f69e6b87f65!2sDentist%20in%20Austin!5e1!3m2!1sen!2sin!4v1756790337341!5m2!1sen!2sin',
  iframeTitle: "Dentist In Austin",

  //membership
  membership: "https://member.kleer.com/?slug=RE6D",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalPartners-DentistInAustin",

  // Cherry
  cherryUrl: "https://dentistinaustintx.com/patient-portal",

  // Analytics
  gaMeasurementId: "G-XFZ4SN71H7",
  clarityProjectId: "q5ntnauzgw",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-11559302269",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-11559302269/QLJyCKzzw5QcEP3o84cr",
    "contact_form_success": "AW-11559302269/aIJCCJm0roYcEP3o84cr",
    "call_back_success": "AW-11559302269/_wRGCLOxwoYcEP3o84cr",
    "chatbot_phone_click": "AW-11559302269/FrkdCPWTzZQcEP3o84cr",
    "chatbot_voice_call": "AW-11559302269/HEZ3CKCEuJQcEP3o84cr",
    "book_appointment_success": "AW-11559302269/_yN3COqgt4YcEP3o84cr",
    "Confirm-Booking": "AW-11559302269/D83GCI-WzZQcEP3o84cr",
    "Submit-Payment": "AW-11559302269/jr9ACNOEuJQcEP3o84cr",
    // Secondary — observation/reporting only
    "sms_click": "AW-11559302269/X5TZCIqGuJQcEP3o84cr",
    "directions_click": "AW-11559302269/KjugCKOEuJQcEP3o84cr",
    "email_click": "AW-11559302269/N0mUCMX0w5QcEP3o84cr",
    "map_click": "AW-11559302269/rkMzCPP5zJQcEP3o84cr",
    "social_media_click": "AW-11559302269/qmxMCNObzZQcEP3o84cr",
    "financing_click": "AW-11559302269/OnjVCOP0w5QcEP3o84cr",
    "membership_click": "AW-11559302269/YOEpCJmGuJQcEP3o84cr",
    "outbound_link_click": "AW-11559302269/sqbyCPqHuJQcEP3o84cr",
    "chat_send": "AW-11559302269/rBsqCN2FuJQcEP3o84cr",
    "chatbot_quick_action": "AW-11559302269/wS2uCJ-GuJQcEP3o84cr",
    "chatbot_insurance_upload": "AW-11559302269/d91wCKWGuJQcEP3o84cr",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinaustin",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinaustin",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinaustin",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinaustintx.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/dentistinaustintanglewood",
    instagram: "https://www.instagram.com/stories/dentistinaustin/",
    twitter: "https://x.com/dent_inaustin",
    linkedin: "https://www.linkedin.com/company/107863979/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@DentistinAustin",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/6054648779618650746/profile?hl=en-GB&fid=307141331480248165",
    facebook: "https://www.facebook.com/dentistinaustintx/",
    yelp: "https://www.yelp.com/biz/dentist-in-austin-austin",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 9,
      AppointmentTypeNum: 6
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 8
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 3
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "17376773926",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

